var React = require('react');
var Extras = require('../../../data/extras.json');
var Frame = require('../../views/Frame');

var createSprite = require('../../../lib/createSprite');
var Utils = require('../../../lib/utils');
var Audio = require('../../../lib/audio');

var CommonAnimations = require('../../../animations/common');
var BucketGuardsAnimations = require('../../../animations/bucketGuards');

var BucketGuards = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        intensity: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string,
        className: React.PropTypes.string,
        title: React.PropTypes.string
    },

    contextTypes: {
        minIntensity: React.PropTypes.number,
        maxIntensity: React.PropTypes.number,
        language: React.PropTypes.string,
    },

    timeline: null,
    sprites: null,
    pixiFlux: null,
    audios: null,
    movieclipTimelines: null,

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: '', // used to be Fortunes privées...
                    subtitle: null,
                    opts: {
                        align: 'center',
                        y: 200,
                        titleStyle: {
                            fontWeight: '700',
                            fontSize: '30px',
                            fontFamily: 'Oswald',
                            lineHeight: 30
                        }
                    }
                }
            ],
            backgroundKey: 'bucketGuardsBg',
            className: 'bucket-guards',
            fluxSettings: require('../../../flux/bucketGuards'),
            audioUrls: {
                flux: ['/audio/28nov/general-liquide-mouv-01.ogg', '/audio/28nov/general-liquide-mouv-01.mp3'],
            },
            title: 'olig',
        }
    },

    render: function()
    {
        // const texts = _.merge(this.props.texts, [
        //     {
        //         title: Extras[this.props.title].text[this.context.language],
        //     },
        // ]);

        return (
            <Frame
                {...this.props}
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                onIntensityChanged={this.updateIntensity}
            />
        );
    },

    build: function(container, timeline, opts)
    {
        this.sprites = {
            container: container
        };
        this.timeline = timeline;
        this.pixiFlux = opts.pixiFlux;

        this.audios = {};
        _.forOwn(this.props.audioUrls, _.bind(function(value, key){
            this.audios[key] = new Audio(value, {
                loop: true,
                channel: 'frame'
            });
        }, this));

        this.buildObjects();
        this.animateObjects();
    },

    play: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeInFast();
        }
    },

    pause: function()
    {
        if (this.audios.flux) {
            this.audios.flux.fadeOutFast();
        }
    },

    destroy: function()
    {
        this.sprites = null;
        this.audios = null;
        this.movieclipTimelines = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;
        var objs = props.objs;
        var container = sprites.container;

        var fluxMask = new PIXI.Graphics();
        fluxMask.beginFill(0xFFFFFF);
        fluxMask.drawRect(0, 0, props.width, props.height * 0.53);
        fluxMask.drawRect(0, props.height * 0.61, props.width, props.height * 0.39);
        fluxMask.endFill();

        var fluxContainer = new PIXI.Container();
        if (this.pixiFlux)
        {
            this.pixiFlux.setContainer(fluxContainer, props.width);
        }
        fluxContainer.mask = fluxMask;

        var bucketUnderObj = objs.bucketUnder;
        var bucketUnder = sprites.bucketUnder = createSprite(bucketUnderObj);
        Utils.setSizeAndPositionFromRefSize(bucketUnder, props.width, props.height, bucketUnderObj);

        var bucketOverObj = objs.bucketOver;
        var bucketOver = sprites.bucketOver = createSprite(bucketOverObj);
        Utils.setSizeAndPositionFromRefSize(bucketOver, props.width, props.height, bucketOverObj);

        var agentMiddleObj = objs.agentMiddle;
        var agentMiddle = sprites.agentMiddle = createSprite(agentMiddleObj);
        Utils.setSizeAndPositionFromRefSize(agentMiddle, props.width, props.height, agentMiddleObj);

        var agentRightObj = objs.agentRight;
        var agentRight = sprites.agentRight = createSprite(agentRightObj);
        Utils.setSizeAndPositionFromRefSize(agentRight, props.width, props.height, agentRightObj);

        var agentLeftObj = objs.agentLeft;
        var agentLeft = sprites.agentLeft = createSprite(agentLeftObj);
        Utils.setSizeAndPositionFromRefSize(agentLeft, props.width, props.height, agentLeftObj);

        agentMiddle.userData = {character: true};
        agentLeft.userData = {character: true};
        agentRight.userData = {character: true};

        container.addChild(fluxMask);
        container.addChild(agentLeft);
        container.addChild(bucketUnder);
        container.addChild(fluxContainer);
        container.addChild(bucketOver);
        container.addChild(agentMiddle);
        container.addChild(agentRight);
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var timeline = this.timeline;

        var agentMovieclipOptions = {
            fps: 3
        };
        this.movieclipTimelines = [
            timeline.add(CommonAnimations.getMovieclipTimeline(sprites.agentLeft, agentMovieclipOptions), 0),
            timeline.add(CommonAnimations.getMovieclipTimeline(sprites.agentMiddle, agentMovieclipOptions), 0.1),
            timeline.add(CommonAnimations.getMovieclipTimeline(sprites.agentRight, agentMovieclipOptions), 0.2)
        ];

        if (this.props.onAnimationReady)
        {
            this.props.onAnimationReady(timeline);
        }
    },

    updateIntensity: function(prevIntensity)
    {
        var props = this.props;
        var context = this.context;

        var intensity = props.intensity;
        var minIntensity = context.minIntensity;
        var maxIntensity = context.maxIntensity;

        prevIntensity = typeof prevIntensity !== 'undefined' ? prevIntensity: intensity;

        // movieclip timelines
        _.each(this.movieclipTimelines, function(movieclipTimeline){
            movieclipTimeline.timeScale(1 + (intensity-2) * 0.15);
        });

        if (prevIntensity !== intensity)
        {
            BucketGuardsAnimations.initBucketPump(this.pixiFlux, intensity);
        }

        BucketGuardsAnimations.updateBucketIntensity(this.pixiFlux, {
            intensity: intensity,
            minIntensity: minIntensity,
            maxIntensity: maxIntensity
        });
    }

});

module.exports = BucketGuards;



// WEBPACK FOOTER //
// ./js/components/frames/E-Oligarchie/7-BucketGuards.jsx